const pdfBlobCache = new Map();

export const normalizeFileUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  return url.trim();
};

export const loadPdfBlobUrl = async (fileUrl, attempt = 0) => {
  const normalizedUrl = normalizeFileUrl(fileUrl);
  if (!normalizedUrl) {
    throw new Error("Missing file URL");
  }

  if (pdfBlobCache.has(normalizedUrl)) {
    return pdfBlobCache.get(normalizedUrl);
  }

  const token = localStorage.getItem("accessToken");
  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

  try {
    let response = await fetch(normalizedUrl, {
      method: "GET",
      credentials: "include",
      headers: authHeaders,
    });

    if (!response.ok) {
      response = await fetch(normalizedUrl, { method: "GET" });
    }

    if (!response.ok) {
      throw new Error("Failed to load PDF");
    }

    const rawBlob = await response.blob();
    if (!rawBlob.size) {
      throw new Error("Empty PDF file");
    }

    const pdfBlob =
      rawBlob.type === "application/pdf"
        ? rawBlob
        : new Blob([rawBlob], { type: "application/pdf" });

    const blobUrl = URL.createObjectURL(pdfBlob);
    pdfBlobCache.set(normalizedUrl, blobUrl);
    return blobUrl;
  } catch (error) {
    if (attempt < 2) {
      await new Promise((resolve) => setTimeout(resolve, 400 * (attempt + 1)));
      return loadPdfBlobUrl(fileUrl, attempt + 1);
    }
    throw error;
  }
};

export const clearPdfBlobCache = () => {
  pdfBlobCache.forEach((blobUrl) => URL.revokeObjectURL(blobUrl));
  pdfBlobCache.clear();
};

export const downloadPdfFile = async (url, fileName) => {
  const normalizedUrl = normalizeFileUrl(url);
  if (!normalizedUrl) return;

  const blobUrl = await loadPdfBlobUrl(normalizedUrl);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
};
